import React from 'react';
import PrivacyContent from 'components/root/guidance/privacy/PrivacyContent';

export const PrivacyPage: React.FC = () => {
  return <PrivacyContent />;
};
